import './RangeSelector.css';

function formatTime(totalSeconds) {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}` : `${m}:${String(s).padStart(2, '0')}`;
}

export default function RangeSelector({ disabled, duration, endSeconds, setEndSeconds, setStartSeconds, startSeconds }) {
  if (!duration) return null;
  return (
    <div className={`time-range-selector ${disabled ? 'disabled' : ''}`}>
      <div className="time-range-labels">
        <span className="time-label"><span className="time-label-title">Inici</span><span className="time-label-value">{formatTime(startSeconds)}</span></span>
        <span className="time-label center"><span className="time-label-title">Durada seleccionada</span><span className="time-label-value">{formatTime(endSeconds - startSeconds)}</span></span>
        <span className="time-label"><span className="time-label-title">Fi</span><span className="time-label-value">{formatTime(endSeconds)}</span></span>
      </div>
      <div className="range-slider-container">
        <div className="range-slider-track" style={{ '--start-percent': `${(startSeconds / duration) * 100}%`, '--end-percent': `${(endSeconds / duration) * 100}%` }}><div className="range-slider-selected" /></div>
        <input aria-label="Inici" type="range" className="range-slider range-slider-start" min="0" max={duration} value={startSeconds} disabled={disabled} onChange={(event) => { const value = Number(event.target.value); if (value < endSeconds) setStartSeconds(value); }} />
        <input aria-label="Fi" type="range" className="range-slider range-slider-end" min="0" max={duration} value={endSeconds} disabled={disabled} onChange={(event) => { const value = Number(event.target.value); if (value > startSeconds) setEndSeconds(value); }} />
      </div>
      <div className="time-range-endpoints"><span>0:00</span><span>{formatTime(duration)}</span></div>
    </div>
  );
}
